/* image_type_nxos.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <path class="foreground-gl" d="M19.77.28H2.85A2.23,2.23,0,0,0,.62,2.51V18.08A2.32,2.32,0,0,0,2.94,20.4H19.59a2.53,2.53,0,0,0,2.52-2.52V2.62A2.34,2.34,0,0,0,19.77.28ZM16.55,15.61h-2.9L9.4,7.93h0l.06,7.68H6.94V3.87H9.85l4.24,7.66h0l-.06-7.66h2.48Z"/>
        </svg>
    `
};
